<div class="container">
  <div class="room-list mt-3 mb-3" *ngIf="coffeeConfigs.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Office</th>
        <th scope="col">Booking Option</th>
        <th scope="col">Value</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let coffeeConfig of coffeeConfigs">
        <th scope="row">{{ coffeeConfig.id }}</th>
        <td>{{ getOffice(coffeeConfig.officeId) }}</td>
        <td>{{ coffeeConfig.bookingOption }}</td>
        <td>{{ coffeeConfig.value }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(coffeeConfig)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(coffeeConfig)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
